module.exports = __webpack_public_path__ + "static/img/left-pic.1a19b84f.png";